import { Button } from "@components/Buttons"
import { breakpoints } from "@config/theme"
import { motion } from "framer-motion"
import { rem } from "polished"
import styled, { css } from "styled-components"

export const ToggleButton = styled(Button)<{ active: boolean }>`
  ${(p) =>
    !p.active &&
    css`
      border-color: ${(x) => x.theme.colors.softGrey}!important;
      color: ${(x) => x.theme.colors.text.light};
    `}

  &:hover,
  &:active,
  &:focus {
    background: transparent;
  }

  @media screen and (max-width: ${breakpoints.small}) {
    height: ${rem("40px")};
    font-size: ${rem("11px")};
    padding: 0;
    border-width: 1.4px;
  }
`

export const TabWrap = styled(motion.div)<{ allowedTabs: string[] }>`
  display: grid;
  grid-template-columns: repeat(${(p) => p.allowedTabs.length}, 1fr);
  grid-column-gap: 1rem;
  max-width: 38rem;
  width: 100%;

  @media screen and (min-width: ${breakpoints.small}) and (max-width: ${breakpoints.medium}) {
    max-width: inherit;
  }
`
